import axios from "axios";
import qs from "qs";

export default class Api {
  constructor(options) {
    this.ressource = options.ressource;
  }

  get(id) {
    return axios({ url: `/${this.ressource}/${id}`, method: "GET" });
  }
  getAll(filters = {}) {
    return axios({
      url: `/${this.ressource}`,
      params: filters,
      paramsSerializer: params => qs.stringify(filters, {
        arrayFormat: "brackets",
        skipNulls: true,
        filter: (prefix, value) => value !== "" ? value : undefined,
        encoder: (str, defaultEncoder) => defaultEncoder(typeof str === "string" ? str.trim() : str)
      }),
      method: "GET"
    });
  }
  post(data = {}) {
    return axios({
      url: `/${this.ressource}`,
      data,
      method: "POST"
    });
  }
}
